export const DATA_AUTOMATION_VALUE = "rating-cell";
